import icX from 'assets/images/ic-x.svg'
import { Button, Modal } from 'avo-ui'
import { useRef } from 'react'
import icLogo from 'assets/images/logo-blue.png'
import Barcode from 'react-barcode'
import './print-a6.scss'
import { formatDateMoment, getHeight } from 'utils/utils'
import { useReactToPrint } from 'react-to-print'
import moment from 'moment'

export const PrintLabelModal = ({ show, onHide, printLabelHandler, isLoading, list }) => {
    const contentRef = useRef(null)
    const reactToPrintFn = useReactToPrint({
        contentRef,
        documentTitle: `MSBB Label - ${moment().format('DD-MM-YYYY HH-mm')}`,
    })

    return (
        <Modal dialogClassName={'w-[450px]'} contentClassName={'rounded-xl overflow-auto'} show={show} onHide={onHide}>
            <div className={'flex px-3 pt-3 justify-end'}>
                <img className={'w-5 cursor-pointer'} src={icX} alt='ic-x' onClick={onHide} />
            </div>
            <div className={'flex flex-col justify-center text-black-95 text-[10px] font-bold'} ref={contentRef}>
                {list?.map((data, index) => (
                    <div key={index} className={`size-a6 px-2 w-[105mm] ${getHeight(data?.items?.length)}`}>
                        <div className={'flex justify-between items-center px-2'}>
                            <img src={icLogo} className={'h-12'} alt={'logo'} />
                            {data?.awb && (
                                <Barcode
                                    value={data?.awb}
                                    textPosition={'bottom'}
                                    textMargin={5}
                                    height={30}
                                    width={1.3}
                                    fontSize={13}
                                />
                            )}
                            <img
                                src={data?.shipping_service?.image_url}
                                alt={'expedition'}
                                className={'h-7 w-20 object-contain'}
                            />
                        </div>
                        <div className={'flex flex-col divide-y divide-black-95'}>
                            <div className={'grid grid-cols-2 gap-3 py-1 pr-5 pl-2'}>
                                <div className={'flex items-center space-x-2'}>
                                    <p>Jenis Layanan</p>
                                    <p>{data?.shipping_service?.name}</p>
                                </div>
                                <div className={'flex items-center space-x-2'}>
                                    <p>Tanggal Order</p>
                                    <p>{formatDateMoment(data?.order_date, 'DD/MM/YYYY HH:mm')}</p>
                                </div>
                            </div>
                            <div className={'grid grid-cols-2 divide-x divide-black-95'}>
                                <div className={'flex flex-col justify-center items-center'}>
                                    <Barcode
                                        value={data?.order_code}
                                        textPosition={'bottom'}
                                        textMargin={5}
                                        height={30}
                                        width={1.3}
                                        fontSize={13}
                                    />
                                </div>
                                <div className={'flex flex-col divide-y divide-black-95'}>
                                    <div className={'flex items-center space-x-5 pl-2 py-1'}>
                                        <p className={'font-NunitoSans-Bold'}>Asuransi</p>
                                        <p>-</p>
                                    </div>
                                    <div className={'flex items-center space-x-5 pl-2 py-1'}>
                                        <p>Berat</p>
                                        <p>{data?.total_weight} Kg</p>
                                    </div>
                                    <div className={'flex items-center space-x-5 pl-2 pt-1'}>
                                        <p>Quantity</p>
                                        <p>{data?.total_quantity} pcs</p>
                                    </div>
                                </div>
                            </div>
                            <div className={'grid grid-cols-2 gap-3 py-1 pr-5 pl-2'}>
                                <div>
                                    <p>Nama Penerima</p>
                                    <p className={'capitalize'}>{data?.customer?.name}</p>
                                </div>
                                <div>
                                    <p>Nama Pengirim</p>
                                    <p>{data?.origin?.name}</p>
                                </div>
                            </div>
                            <div className={'grid grid-cols-2 gap-3 py-1 pr-5 pl-2'}>
                                <div>
                                    <p>Alamat Penerima</p>
                                    <p className={'text-left'}>{data?.customer?.address}</p>
                                </div>
                                <div>
                                    <p>Alamat Pengirim</p>
                                    <p className={'text-left'}>{data?.origin?.address}</p>
                                </div>
                            </div>
                            <div className={'grid grid-cols-2 gap-3 py-1 pr-5 pl-2'}>
                                <div>
                                    <p>Nomor Telpon Penerima</p>
                                    <p>{data?.customer?.phone_number}</p>
                                </div>
                                <div>
                                    <p>Nomor Telpon Pengirim</p>
                                    <p>{data?.origin?.phone_number}</p>
                                </div>
                            </div>
                            <div className={'py-1 pl-2'}>
                                <p>Catatan</p>
                                <p>{data?.note}</p>
                            </div>
                            <div className={'pr-5 py-1 pl-2'}>
                                <p>Detail Barang</p>
                                {data?.items?.map((i, index) => (
                                    <div key={index} className={'flex items-center justify-between w-full'}>
                                        <p>{i?.name}</p>
                                        <p>{i?.quantity}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className={'flex items-center justify-between my-5 mx-4'}>
                <Button title={'Pindah ke Pengemasan'} loading={isLoading} onClick={printLabelHandler} />
                <Button title={'Print Label'} onClick={reactToPrintFn} />
            </div>
        </Modal>
    )
}
